<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2019 (original work) Open Assessment Technologies SA ;
    import { createEventDispatcher } from 'svelte';
    import { Checkbox } from '@oat-sa-private/ui-elements';

    export let data = {};

    const dispatch = createEventDispatcher();

    const onChange = e => {
        dispatch('action', { type: data.actionType || 'check', options: { checked: e.detail } });
    };
</script>

<Checkbox
    {...data}
    bind:checked={data.checked}
    on:change={onChange}
    on:click={evt => evt.stopPropagation()} />
